import { useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'

export const useGetAppInfo = () => {
  const get = useTypedApiClient({
    path: '/admin/appInfo',
    method: 'get',
  })

  return useQuery({
    queryKey: ['/admin/appInfo'],
    queryFn: async () => {
      const res = await get({})
      const { data } = res
      if (!data) {
        return null
      }
      return data
    },
  })
}
